import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import productData from "../Datas/productData";
import { ProductCard } from "./Shop";
import "../css/main.scss";

function Main() {
  useEffect(() => {
    document.title = "tastevani — Contemporary Footwear";
  }, []);

  return (
    <main className="home">
      <section className="home-hero">
        <img src="/img/editorial/hero.jpg" alt="Woman walking through a sunny courtyard in burgundy sneakers" />
        <div className="home-hero__content shell">
          <p className="eyebrow">Footwear Collection</p>
          <h1>Every step,<br />your style</h1>
          <p>Clean lines, versatile colours and everyday comfort.</p>
          <Link className="btn" to="/shop?sort=new">Explore the collection <FiArrowRight /></Link>
        </div>
      </section>

      <section className="home-intro shell">
        <p className="eyebrow">tastevani</p>
        <h2>Footwear selected<br /><em>for freedom of movement.</em></h2>
        <p>
          Our collection brings together sneakers, loafers, boots, flats and sandals in an easy-to-style palette.
        </p>
      </section>

      <section className="home-categories shell" aria-label="Main categories">
        <Link className="category-card category-card--large" to="/shop">
          <img src="/img/editorial/collection.jpg" alt="Original amber ankle boot in a clean studio setting" loading="lazy" />
          <span><small>The Collection</small><strong>Footwear</strong><i>View all <FiArrowRight /></i></span>
        </Link>
        <div className="home-categories__stack">
          <Link className="category-card" to="/shop?search=loafer">
            <img src={productData[4].images[0]} alt="Chocolate loafer with lug sole" loading="lazy" />
            <span><small>For the city</small><strong>Loafers & Derbies</strong><i>Explore <FiArrowRight /></i></span>
          </Link>
          <Link className="category-card" to="/shop?search=sandal">
            <img src={productData[15].images[0]} alt="Tan woven sandal" loading="lazy" />
            <span><small>Lightweight styles</small><strong>Sandals</strong><i>Explore <FiArrowRight /></i></span>
          </Link>
        </div>
      </section>

      <section className="home-products">
        <header className="section-heading shell">
          <div>
            <p className="eyebrow">Just arrived</p>
            <h2>New Arrivals</h2>
          </div>
          <Link className="link-arrow" to="/shop?sort=new">View all <FiArrowRight /></Link>
        </header>
        <div className="product-grid shell">
          {productData.slice(0, 4).map((product) => <ProductCard key={product.id} product={product} eager />)}
        </div>
      </section>

      <section className="home-manifesto">
        <div className="home-manifesto__image">
          <img src="/img/editorial/manifesto.jpg" alt="Original chocolate loafer in a clean studio setting" loading="lazy" />
        </div>
        <div className="home-manifesto__content">
          <p className="eyebrow">A versatile collection</p>
          <h2>A pair for every moment.</h2>
          <p>
            From casual sneakers to smarter styles, every product page clearly shows the material, fit and available sizes.
          </p>
          <Link className="btn btn--outline" to="/about">Our approach</Link>
        </div>
      </section>

      <section className="home-icons shell">
        <article><span>01</span><h3>Footwear only</h3><p>Every product in our shop is a pair of shoes or boots.</p></article>
        <article><span>02</span><h3>Clear sizing</h3><p>Available sizes are listed on every product page.</p></article>
        <article><span>03</span><h3>GBP payments</h3><p>All prices and totals are displayed in pounds sterling.</p></article>
        <article><span>04</span><h3>Clear returns</h3><p>Read our conditions before sending your pair back.</p></article>
      </section>

      <section className="home-products home-products--second">
        <header className="section-heading shell">
          <div>
            <p className="eyebrow">Customer favourites</p>
            <h2>Signature Styles</h2>
          </div>
          <Link className="link-arrow" to="/shop">Shop all <FiArrowRight /></Link>
        </header>
        <div className="product-grid shell">
          {productData.slice(8, 12).map((product) => <ProductCard key={product.id} product={product} />)}
        </div>
      </section>

      <section className="home-about shell">
        <img src="/img/editorial/workshop.jpg" alt="Craftsperson assembling a sneaker in a workshop" loading="lazy" />
        <div>
          <p className="eyebrow">Our selection</p>
          <h2>Shapes that fit your everyday life</h2>
          <p>
            We keep the range easy to navigate, with contemporary silhouettes, versatile colours and useful product details.
          </p>
          <Link className="link-arrow" to="/about">Discover our story <FiArrowRight /></Link>
        </div>
      </section>
    </main>
  );
}

export default Main;
